// extracted by mini-css-extract-plugin
export default {"root":"Meeting_root__BS2rY","header":"Meeting_header__0LbCj","body":"Meeting_body__1FiaN","section":"Meeting_section__cFFrn","infoItem":"Meeting_infoItem__2lVfA"};